import * as React from "react";

import BoxContainer from "@hl/base-components/lib/BoxContainer";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import {
  Checked,
  NotChecked,
} from "@hl/shared-features/lib/assets/icons.generated";
import { Grid, Text } from "@mantine/core";

export const SelectBox = ({
  label,
  description,
  checked,
  onClick,
  disabled = false,
}: {
  label: string;
  description?: string;
  checked: boolean;
  disabled?: boolean;
  onClick: () => void;
}) => (
  <BoxContainer
    w="100%"
    h="100%"
    sx={(theme) => ({
      cursor: "pointer",
      border: checked ? `2px solid ${theme.colors.primaryText[0]}` : undefined,
      ...(disabled && { opacity: "0.3" }),
    })}
    onClick={() => {
      if (!disabled) return onClick();
    }}
  >
    <Grid gutter={16} align="flex-start" justify="space-between" grow>
      <Grid.Col span={10}>
        <Text size="sm">{label}</Text>
        {description && (
          <Text size="sm" color={TEXT_COLOR.SECONDARY}>
            {description}
          </Text>
        )}
      </Grid.Col>
      <Grid.Col pb={0} span="auto">
        {checked ? <Checked width={20} /> : <NotChecked width={20} />}
      </Grid.Col>
    </Grid>
  </BoxContainer>
);
